// extracted by mini-css-extract-plugin
module.exports = {"ads":"Dashboard_ads__1ltZo","banner":"Dashboard_banner__1SBy3","desktopBanner":"Dashboard_desktopBanner__3mHxR","mobileBanner":"Dashboard_mobileBanner__2znQk"};